<template>
  <el-dialog
    title="核心组人员编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :model="CoreEditForm" label-position="right">
      <el-form-item label="核心组">
        <el-input v-model="CoreEditForm.core_id" autocomplete="off" placeholder="例：1,2,3...或者为空"></el-input>
      </el-form-item>
      <el-form-item label="人员类别">
          <el-select style="width:100%;"  v-model="CoreEditForm.type"  placeholder="选择人员类别（首席科学家、组长、副组长、组员）" autocomplete="off">
                <el-option
                    v-for="item in coretype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>          
      </el-form-item>
      <el-form-item label="姓名">
          <el-input v-model="CoreEditForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="邮件地址">
          <el-input v-model="CoreEditForm.mail" autocomplete="off"></el-input>
      </el-form-item>      
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {CoreType} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      CoreEditForm: {
        core_id: '',
        type: '',
        name: '',
        mail:'',
        ind:'',
      },
      coretype:CoreType,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.CoreEditForm.core_id = data.core_id;
      this.CoreEditForm.type = data.type;
      this.CoreEditForm.name = data.name;
      this.CoreEditForm.mail = data.email;
      this.CoreEditForm.ind = data.ind;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.CoreEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
